import { createSlice } from '@reduxjs/toolkit';
// import { LoginForm, LoginResponse, RegisterDataRequest, RegisterUser, RequestError } from "../../types/auth";
import { PayloadAction } from '@reduxjs/toolkit';
import { PackageType } from 'src/shared/interface/connection';
// import {User} from "../../types/user";
import { v4 as uuidv4 } from 'uuid';

export interface GlobalState {
  token: string;
  role: string[];
  loading: boolean;
  showGoBack: boolean;
  refresh: boolean;
  contentModal: string;
  visibleModal: boolean;
  titleModal: string;
  contentModalWithIcon: string;
  visibleModalWithIcon: boolean;
  titleModalWithIcon: string;
  userName: string;
  queryStringPrevious: any;
  isAdvancedSearch: boolean;
  deviceId: string;
  requestId: string;
  openTabs: any[];
  activeKeyMenu: string;
  activeKeyId: string;
  isOpenPayment: boolean;
  order?: any;
  balance: number;
  balanceData: number;
  payAccountData?: string;
  masterData?: any;
  listPackageType: PackageType[];
  isJobProgressModalOpen: boolean;
  jobProcessedCount: number;
  jobTotalCount: number;
  jobStatusName: string;
  jobStatus?: number;
}
const initialState: GlobalState = {
  token: '',
  role: [''],
  loading: false,
  showGoBack: true,
  visibleModal: false,
  refresh: false,
  contentModal: '',
  titleModal: '',
  userName: '',
  contentModalWithIcon: '',
  visibleModalWithIcon: false,
  titleModalWithIcon: '',
  queryStringPrevious: [],
  isAdvancedSearch: false,
  deviceId: uuidv4(),
  requestId: uuidv4(),
  openTabs: [
    {
      key: `dashboard`,
      label: `Dashboard`,
      children: '',
      closable: false,
    },
  ],
  activeKeyMenu: '',
  activeKeyId: '',
  isOpenPayment: false,
  order: undefined,
  balance: 0,
  balanceData: 0,
  masterData: {},
  listPackageType: [],
  isJobProgressModalOpen: false,
  jobProcessedCount: 0,
  jobTotalCount: 0,
  jobStatusName: '',
};
export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setGlobalState(state, action: PayloadAction<Partial<GlobalState>>) {
      Object.assign(state, action.payload);
    },
    reset(state: any) {
      Object.keys(state).forEach((stateKey) => {
        Object.keys(initialState).forEach((initStateKey) => {
          if (stateKey === initStateKey) {
            state[stateKey] = { ...initialState }[initStateKey];
          }
        });
      });
    },
  },
});

export const { actions: globalAction, reducer: globalReducer } = globalSlice;
export const { setGlobalState, reset } = globalSlice.actions;
